"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const THREE = __importStar(require("three"));
const consts_1 = require("../consts");
class RendererHelper extends THREE.WebGLRenderer {
    constructor(canvas, scene, camera) {
        super({
            antialias: true,
            canvas,
            preserveDrawingBuffer: true,
        });
        this.localClippingEnabled = true;
        this.camera = camera;
        this.scene = scene;
        this.setPixelRatio(window.devicePixelRatio);
        this.setClearColor(consts_1.consts.CLEAR_COLOR, 1);
        this.setSize(window.innerWidth, window.innerHeight);
    }
}
exports.default = RendererHelper;
